import { useState } from "react";
import { UserX } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { useApi } from "../../lib/useApi";
import { api, formatApiError } from "../../lib/api";
import { Loader, ErrorState, EmptyState, PageHeader } from "../../components/common/States";
import { ConfirmButton } from "../../components/common/ConfirmButton";
import { fmtDate } from "../../lib/labels";

const LABEL = { pending: "En attente", approved: "Supprimé", rejected: "Refusée", cancelled: "Annulée" };

export default function AdminDeletions() {
  const [status, setStatus] = useState("pending");
  const { data, loading, error, reload } = useApi(`/admin/deletion-requests?status=${status}`);
  const decide = async (r, action) => {
    try { await api.post(`/admin/deletion-requests/${r.id}`, { action }); toast.success(action === "approve" ? "Compte supprimé et anonymisé" : "Demande refusée"); reload(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  return (
    <div>
      <PageHeader title="Suppressions de compte" description="Demandes de suppression envoyées par les usagers depuis leur espace."
        actions={<select className="field-select w-44" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="admin-deletions-status-filter">
          <option value="pending">En attente</option><option value="">Toutes</option>
        </select>} />
      {loading && <Loader />}
      {error && <ErrorState message={error} onRetry={reload} />}
      {data && !data.length && <EmptyState icon={UserX} title="Aucune demande" />}
      <div className="space-y-3">
        {data?.map((r) => (
          <div key={r.id} className="card-surface flex flex-col gap-3 p-5 sm:flex-row sm:items-center" data-testid={`admin-deletion-${r.id}`}>
            <div className="flex-1">
              <p className="font-medium">{r.name} <span className="text-sm font-normal text-slate-500">{r.email}</span></p>
              <p className="text-xs text-slate-400">{fmtDate(r.created_at)} · {LABEL[r.status]}</p>
              {r.reason && <p className="mt-1 text-sm text-slate-600">« {r.reason} »</p>}
            </div>
            {r.status === "pending" && (
              <div className="flex gap-2">
                <Button size="sm" variant="outline" onClick={() => decide(r, "reject")} data-testid={`admin-deletion-reject-${r.id}`}>Refuser</Button>
                <ConfirmButton testId={`admin-deletion-approve-${r.id}`} title="Supprimer définitivement ce compte ?" description="Les données personnelles seront effacées et les feedbacks anonymisés."
                  confirmLabel="Supprimer" onConfirm={() => decide(r, "approve")}
                  trigger={<Button size="sm" variant="destructive" data-testid={`admin-deletion-approve-${r.id}`}>Approuver</Button>} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
